import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

/** 邀请码展开箭头（设计稿） */
const InvitePullDownIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 4.25L6 7.75L9.5 4.25"
        stroke="#8A8A8A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export default InvitePullDownIcon;
